module.exports = "<h3>list-tpl</h3>\n<section style=\"margin-top: 30px;\">\n  <div>\n      <pre>\n        <code class=\"language-html\" ng-bind-html=\"vm.exampleHtml\"></code>\n      </pre>\n  </div>\n</section>\n<h3>示例</h3>\n<list-tpl config=\"vm.config\"></list-tpl>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./examples/template/list/template.html
 ** module id = 222
 ** module chunks = 0
 **/